import cogoToast from 'cogo-toast';
import { createSlice } from '@reduxjs/toolkit';
import { API_WEB_URLS } from '../../constants/constAPI';
import { API_HELPER } from '../../helpers/ApiHelper';

const wishlistSlice = createSlice({
    name: "wishlist",
    initialState: {
        wishlistItems: []
    },
    reducers: {
        setWishlistItems(state, action) {
            state.wishlistItems = action.payload;
        },
        addToWishlistSuccess(state, action) {
            const isInWishlist = state.wishlistItems.findIndex(item => item.id === action.payload.id);
            if(isInWishlist > -1){
                cogoToast.info("Product already in wishlist", {position: "bottom-left"});
            } else {
                state.wishlistItems.push(action.payload);
                cogoToast.success("Added To wishlist", {position: "bottom-left"});
            }
        },
        deleteFromWishlistSuccess(state, action){
            state.wishlistItems = state.wishlistItems.filter(item => item.id !== action.payload);
            cogoToast.error("Removed From Wishlist", {position: "bottom-left"});
        },
        deleteAllFromWishlistSuccess(state){
            state.wishlistItems = []
        }
    },
});

export const { setWishlistItems, addToWishlistSuccess, deleteFromWishlistSuccess, deleteAllFromWishlistSuccess } = wishlistSlice.actions;

export const addToWishlist = (product) => async (dispatch) => {
    const firstDesign = product.designDetails && product.designDetails.length > 0 ? product.designDetails[0] : null;
    const designId = firstDesign ? (firstDesign.ItemDesignId || firstDesign.Id || product.id) : product.id;
    const wishlistProduct = { ...product, id: String(designId) };
    
    dispatch(addToWishlistSuccess(wishlistProduct));
    
    const userDataStr = localStorage.getItem("userData");
    if (userDataStr) {
        try {
            const userData = JSON.parse(userDataStr);
            const actualData = userData.data?.response?.[0] || userData.response?.[0] || userData[0] || userData;
            const userId = actualData.Id || actualData.id || actualData.UserId || "0";
            const userToken = actualData.Token || actualData.token || actualData.UserToken || "token";

            const formData = new FormData();
            formData.append("F_ItemDesignMaster", String(designId));

            const url = `${API_WEB_URLS.BASE}Wishlist/${userId}/${userToken}`;
            await API_HELPER.apiPOST_Multipart(url, formData);
            dispatch(fetchWishlist());
        } catch (e) {
            console.error("Error adding to wishlist API", e);
        }
    }
};

export const deleteFromWishlist = (productId) => async (dispatch, getState) => {
    const state = getState();
    const itemToDelete = state.wishlist.wishlistItems.find(item => item.id === productId);
    
    dispatch(deleteFromWishlistSuccess(productId));
    
    if (itemToDelete && itemToDelete.wishlistItemId) {
        const userDataStr = localStorage.getItem("userData");
        if (userDataStr) {
            try {
                const userData = JSON.parse(userDataStr);
                const actualData = userData.data?.response?.[0] || userData.response?.[0] || userData[0] || userData;
                const userId = actualData.Id || actualData.id || actualData.UserId || "0";
                const userToken = actualData.Token || actualData.token || actualData.UserToken || "token";

                const url = `${API_WEB_URLS.BASE}Wishlist/${userId}/${userToken}/${itemToDelete.wishlistItemId}`;
                await API_HELPER.apiDELETE(url);
            } catch (e) {
                console.error("Error deleting from wishlist API", e);
            }
        }
    }
};

export const deleteAllFromWishlist = () => async (dispatch) => {
    dispatch(deleteAllFromWishlistSuccess());
};

export const fetchWishlist = () => async (dispatch) => {
    const userDataStr = localStorage.getItem("userData");
    if (userDataStr) {
        try {
            const userData = JSON.parse(userDataStr);
            const actualData = userData.data?.response?.[0] || userData.response?.[0] || userData[0] || userData;
            const userId = actualData.Id || actualData.id || actualData.UserId || "0";
            const userToken = actualData.Token || actualData.token || actualData.UserToken || "token";

            const url = `${API_WEB_URLS.BASE}Wishlist/${userId}/${userToken}`;
            const res = await API_HELPER.apiGET(url);
            
            if (res && res.data) {
                const apiItems = res.data.list || res.data.response || res.data;
                if (Array.isArray(apiItems)) {
                    const mappedItems = apiItems.map(item => ({
                        id: item.ItemDesignId ? item.ItemDesignId.toString() : (item.F_ItemDesignMaster || item.Id),
                        wishlistItemId: item.WishlistItemId,
                        name: item.ItemName || item.Name || "Wishlist Item",
                        price: item.SalePrice || item.Price || 0,
                        image: [item.DesignPhoto ? (item.DesignPhoto.startsWith("http") ? item.DesignPhoto : API_WEB_URLS.IMAGEURL + item.DesignPhoto) : "/assets/img/no-image.png"],
                        discount: item.DiscountPercent || item.Discount || 0,
                        stock: item.AvailableQty || 100,
                        shortDescription: item.ShortDescription || "",
                        fullDescription: item.FullDescription || ""
                    }));
                    dispatch(setWishlistItems(mappedItems));
                }
            }
        } catch (e) {
            console.error("Error fetching wishlist", e);
            
        }
    }
};

export default wishlistSlice.reducer;
